export default __webpack_public_path__ + "static/media/img-10-sihir.f22a886c.jpg";